import { securedHttpClient } from "@/api/httpClient";

export const getCourseAttendanceList = (courseId: any) => securedHttpClient.get(`/course/${courseId}/attendance`);

export const getDayList = (courseId: any) => securedHttpClient.get(`/course/${courseId}/participant`);

export const postAttendance = (payload: any) =>
  securedHttpClient.post(`/course/${payload.courseId}/attendance`, payload);
